import component from './MarkdownComponent.vue'
export default component
